module.exports = __webpack_public_path__ + "static/media/trashbin.caf3a75d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/icons/trashbin.png
 ** module id = 2354
 ** module chunks = 44
 **/